(function () {
  var dialog = null;
  var target = null;
  var currentEl = null;
  var totalEl = null;
  var statusEl = null;
  var prevBtn = null;
  var nextBtn = null;
  var countEl = null;

  var triggers = [];
  var index = 0;
  var preloaded = {};
  var swipeStartX = null;
  var swipeHandled = false;

  function resolve() {
    var found = document.querySelector('[data-image-zoom]');
    if (!found || typeof found.showModal !== 'function') return false;
    if (found === dialog) return true;

    dialog = found;
    target = dialog.querySelector('[data-zoom-target]');
    currentEl = dialog.querySelector('[data-zoom-current]');
    totalEl = dialog.querySelector('[data-zoom-total]');
    statusEl = dialog.querySelector('[data-zoom-status]');
    prevBtn = dialog.querySelector('[data-zoom-prev]');
    nextBtn = dialog.querySelector('[data-zoom-next]');
    countEl = dialog.querySelector('[data-zoom-count]');
    if (!target) {
      dialog = null;
      return false;
    }

    var closeBtn = dialog.querySelector('[data-zoom-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prevBtn)
      prevBtn.addEventListener('click', function () {
        step(-1);
      });
    if (nextBtn)
      nextBtn.addEventListener('click', function () {
        step(1);
      });
    dialog.addEventListener('click', onClick);
    dialog.addEventListener('keydown', onKeydown);
    dialog.addEventListener('pointerdown', onPointerDown);
    dialog.addEventListener('pointerup', onPointerUp);
    dialog.addEventListener('pointercancel', function () {
      swipeStartX = null;
    });
    return true;
  }

  function open(trigger) {
    var group = trigger.closest('[data-zoom-group]') || document;
    triggers = Array.prototype.slice.call(group.querySelectorAll('[data-zoom-trigger]'));
    index = triggers.indexOf(trigger);
    if (index < 0) return;

    var multiple = triggers.length > 1;
    if (prevBtn) prevBtn.hidden = !multiple;
    if (nextBtn) nextBtn.hidden = !multiple;
    if (countEl) countEl.hidden = !multiple;
    if (totalEl) totalEl.textContent = String(triggers.length);

    render();
    // open 属性だけ残った状態で showModal を呼ぶと InvalidStateError になる
    if (!dialog.open) dialog.showModal();
  }

  function close() {
    dialog.close();
  }

  function step(delta) {
    var total = triggers.length;
    index = (index + delta + total) % total;
    render();
  }

  function render() {
    var trigger = triggers[index];
    var src = trigger.dataset.zoomSrc;
    var position = String(index + 1);

    if (currentEl) currentEl.textContent = position;
    if (statusEl) {
      statusEl.textContent = (dialog.dataset.zoomStatusTemplate || '')
        .replace('%index%', position)
        .replace('%total%', String(triggers.length));
    }
    target.alt = trigger.dataset.zoomAlt || '';
    // 寸法が無いトリガーで前の画像の値が残ると、読み込み完了までそのアスペクト比で場所を取る
    if (trigger.dataset.zoomWidth && trigger.dataset.zoomHeight) {
      target.width = Number(trigger.dataset.zoomWidth);
      target.height = Number(trigger.dataset.zoomHeight);
    } else {
      target.removeAttribute('width');
      target.removeAttribute('height');
    }

    // 高解像度が届くまではトリガー内のサムネイルを出す。空のまま待つと切り替えのたびに白く抜ける
    var hires = new Image();
    hires.src = src;
    if (hires.complete) {
      target.src = src;
    } else {
      var thumb = trigger.querySelector('img');
      target.src = (thumb && (thumb.currentSrc || thumb.src)) || src;
      hires.addEventListener(
        'load',
        function () {
          if (triggers[index] === trigger) target.src = src;
        },
        { once: true },
      );
    }

    preloadNeighbors();
  }

  function preloadNeighbors() {
    var total = triggers.length;
    if (total < 2) return;
    [-1, 1].forEach(function (offset) {
      var src = triggers[(index + offset + total) % total].dataset.zoomSrc;
      if (!src || preloaded[src]) return;
      preloaded[src] = true;
      var img = new Image();
      img.src = src;
    });
  }

  function onClick(event) {
    // スワイプの終点でクリックが発火するため、直後の 1 回だけ閉じるのを抑える
    if (swipeHandled) {
      swipeHandled = false;
      return;
    }
    if (event.target.closest('[data-zoom-prev], [data-zoom-next], [data-zoom-close]')) return;
    close();
  }

  function onKeydown(event) {
    if (triggers.length < 2) return;
    if (event.key === 'ArrowLeft') step(-1);
    else if (event.key === 'ArrowRight') step(1);
  }

  function onPointerDown(event) {
    if (event.pointerType === 'mouse') return;
    swipeStartX = event.clientX;
  }

  function onPointerUp(event) {
    if (swipeStartX == null) return;
    var distance = event.clientX - swipeStartX;
    swipeStartX = null;
    if (Math.abs(distance) < 40) return;
    swipeHandled = true;
    if (triggers.length < 2) return;
    step(distance < 0 ? 1 : -1);
  }

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;
    var trigger = event.target.closest('[data-zoom-trigger]');
    if (!trigger) return;
    if (!resolve()) return;
    event.preventDefault();
    open(trigger);
  });
})();
